import { memo } from 'react'

interface EmojiProps {
  emoji: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
  className?: string
  onClick?: () => void
}

const sizeClasses = {
  xs: 'text-lg',
  sm: 'text-2xl',
  md: 'text-3xl',
  lg: 'text-4xl',
  xl: 'text-5xl',
  '2xl': 'text-6xl',
}

const Emoji = memo(({ emoji, size = 'md', className = '', onClick }: EmojiProps) => {
  return (
    <span
      role="img"
      aria-label={emoji}
      className={`emoji-text select-none ${sizeClasses[size]} ${className} ${onClick ? 'cursor-pointer hover:scale-110 transition-transform' : ''}`}
      onClick={onClick}
    >
      {emoji}
    </span>
  )
})

Emoji.displayName = 'Emoji'

export default Emoji
